// extracted by mini-css-extract-plugin
module.exports = {"content":"content-iQ-qj","text":"text-3EKAz","linked":"linked-e0u5q","buttons":"buttons-112iH","cancelButton":"cancelButton-2ey9D","closeButton":"closeButton-dCq4B"};